import React from "react";
import suc from "./suc.gif";
import "./suc.css";
import TaskAltIcon from "@mui/icons-material/TaskAlt";

const SuccessPop = ({ title,status=false }) => {
  return (
    <div className={`succesbox ${status ? 'opacity':"remove"}`}>
      <TaskAltIcon className="suc-ic" />
      <p>{title || "Created Successfully"} </p>
    </div>
  );
};

export default SuccessPop;
